export const PromotionStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  ENDED_EARLY: 'ENDED_EARLY'
});
export const PromotionType = Object.freeze({
  SINGLE_USE_PROMOTION: 'SINGLE_USE_PROMOTION',
  SHARED_PROMOTION: 'SHARED_PROMOTION'
});
export const DiscountType = Object.freeze({
  FLAT_DISCOUNT: 'FLAT_DISCOUNT',
  TIERED_DISCOUNT: 'TIERED_DISCOUNT'
});
export const SubscriptionType = Object.freeze({
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL'
});
export const PromotionOrderBy = Object.freeze({
  CREATION_DATE: 'creationDate',
  START_DATE: 'startDate',
  EXPIRATION_DATE: 'endDate'
});